import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { cssMap } from '@atlaskit/css';
import DatePicker from '@atlaskit/datetime-picker/date-picker';
import { Box } from '@atlaskit/primitives/compiled';

import { asFormDateField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';
import { messages } from './messages';

const styles = cssMap({
	container: {
		maxWidth: '160px',
	},
});

export const PreviewDateInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);

	const intl = useIntl();

	const formField = useFormField({ fieldId });
	const formDateField = asFormDateField(formField);

	if (formDateField === undefined) {
		return <></>;
	}

	return (
		<Box xcss={styles.container}>
			<DatePicker
				id={fieldInputId}
				value={formDateField.value?.date}
				locale={intl.locale}
				testId={`field-input-date-preview-${fieldId}`}
				isDisabled
				shouldShowCalendarButton
				label={formField?.label || intl.formatMessage(messages.dateLabel)}
			/>
		</Box>
	);
};
